import { COLORS } from "../../../../Diathrive/src/utils/Constants";

const styles = {
  container: {
    padding: "24px",
  },
  settingsContainer: {
    display: "flex",
    gap: "16px",
    flexDirection: "row",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  containerItem: {
    width: "340.67px",
    height: "150px",
    background: COLORS.white,
    boxShadow: "8px 8px 20px rgba(151, 172, 191, 0.08)",
    borderRadius: "16px",
    padding: "24px",
    cursor: "pointer",
  },
  iconBg: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.greyBackground,
    width: "40px",
    height: "40px",
    borderRadius: "20px",
  },
  itemInsideLayout: {
    display: "flex",
    gap: "16px",
  },
  itemText: {
    display: "grid",
    gap: "4px",
  },
  divider: {
    marginTop: "40px",
    marginBottom: "48px",
  },
  signout: {
    display: "flex",
    gap: "20px",
    cursor: "pointer",
    alignItems: "center",
  },
  signOutButton: {
    backgroundColor: COLORS.red,
    width: "131.5px",
    height: "56px",
    marginLeft: "24px",
  },
  cancelButton: {
    width: "131.5px",
    height: "56px",
  },
  modelViewStyles: {
    maxWidth: 371,
  },
};

export default styles;
